import { call, put, takeEvery } from 'redux-saga/effects'
import * as auditActions from '../ducks/auditDucks'
import * as auditApi from '@/apis/auditApi'

interface FetchQuerySaga {
  type: string
  payload?: string
}

function* fetchListAudit({ payload: queryString }: FetchQuerySaga) {
  try {
    const res = yield call(auditApi.getListAuditLogs, queryString)
    yield put(auditActions.getListAuditSuccess(res))
  } catch (error) {
    yield put(auditActions.getListAuditFail(error))
  }
}

export default function* watchAudit() {
  yield takeEvery(auditActions.getListAudit.toString(), fetchListAudit)
}
